import React from "react";
import "../css/about.scss";

function About() {
  return (
    <div className="about">
      <h1>About Us</h1>

      <div className="section">
        <h2>Our Mission</h2>
        <p>
          Welcome to DZCPHIFI, your go-to destination for cutting-edge
          electronic products designed to elevate your everyday life and work
          experience. Our mission is to deliver high-quality gadgets that
          enhance convenience and efficiency. Whether you need a portable power
          bank to keep your devices charged, a massage gun to relax your
          muscles, wireless earphones for music on the go, or a precise mouse
          for better control, DZCPHIFI has you covered.
        </p>
      </div>

      <div className="section">
        <h2>Our Story</h2>
        <p>
          DZCP896 was founded with a simple yet powerful vision: to bring
          practical and innovative products to everyone, making technology
          accessible and easy to use. We believe technology should serve people,
          not burden them. That's why we carefully curate every item to ensure
          it offers both functionality and durability.
        </p>
      </div>

      <div className="section">
        <h2>Product Diversity</h2>
        <p>
          At DZCPHIFI, we recognize that each customer has unique needs and
          expectations. That's why we provide a diverse selection of products at
          competitive prices. From essential electronics for home usage to
          office devices that boost productivity, we aim to satisfy various
          requirements in different settings.
        </p>
      </div>

      <div className="section">
        <h2>Customer Satisfaction</h2>
        <p>
          Customer satisfaction is at the core of DZCPHIFI's values. We are
          dedicated to offering exceptional customer service to help you make
          the best purchasing decisions. Whether you have questions or need
          advice, our support team is always ready to assist. We believe that
          through communication and feedback, we can continuously enhance your
          shopping experience.
        </p>
      </div>

      <div className="section">
        <h2>Quality Assurance</h2>
        <p>
          Our commitment to quality is unwavering. Every product undergoes
          thorough quality inspections before reaching the market to ensure
          performance, safety, and durability meet high standards. Through this
          meticulous approach, we aim to earn your trust and become your
          reliable tech product partner.
        </p>
        <p>
          Thank you for choosing DZCPHIFI. Let's embark on a journey filled with
          tech-inspired possibilities.
        </p>
      </div>
    </div>
  );
}

export default About;
